module.exports = __webpack_public_path__ + "img/上下翻转-角标.cc9c39b7.svg";